import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex flex-col items-center justify-center px-4 py-20 overflow-hidden" style={{
    background: 'linear-gradient(180deg, #0a0a0a 0%, #0f0f0f 60%, #111 100%)'
  }} data-id="element-173">
      {/* Subtle radial glow */}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse 60% 50% at 50% 40%, rgba(78,205,196,0.08) 0%, transparent 70%)'
    }} data-id="element-174" />

      <div className="relative z-10 max-w-3xl mx-auto text-center" data-id="element-175">
        {/* Logo */}
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="mb-10" data-id="element-176">
          <img src="https://cdn.magicpatterns.com/uploads/vGUmgZEDgrY5byXLU1AcpB/portada_audio_pro.png" alt="Crecimiento AudioPro" className="w-48 mx-auto mb-0" style={{
          filter: 'none'
        }} data-id="element-177" />
        </motion.div>

        {/* Pre-headline */}
        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.3,
        duration: 0.6
      }} className="text-sm font-semibold tracking-widest uppercase mb-6" style={{
        color: 'var(--color-accent)'
      }} data-id="element-178">
          La Biblioteca Mental que Reprograma lo que el Contenido Nunca Tocó
        </motion.p>

        {/* Main Headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.5,
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-4xl md:text-6xl lg:text-7xl font-black leading-tight mb-8" style={{
        fontFamily: 'Playfair Display, serif',
        color: 'var(--color-text)'
      }} data-id="element-179">
          Leíste 10 libros de crecimiento personal.{' '}
          <span style={{
          color: 'var(--color-accent)'
        }} data-id="element-180">
            Tu cuenta bancaria no lo sabe.
          </span>
        </motion.h1>

        {/* Sub-headline */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.8,
        duration: 0.7
      }} className="text-lg md:text-xl leading-relaxed mb-12" style={{
        color: 'var(--color-text-muted)',
        fontFamily: 'Inter, sans-serif'
      }} data-id="element-181">
          El problema no es tu disciplina. No es tu fe. No es tu inteligencia.
          <br className="hidden md:block" data-id="element-182" />
          <strong style={{
          color: 'var(--color-text)'
        }} data-id="element-183">
            {' '}
            Es tu programación.
          </strong>
        </motion.p>

        {/* CTA */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 1.1,
        duration: 0.5
      }} data-id="element-184"></motion.div>

        {/* Scroll indicator */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1.6,
        duration: 0.6
      }} className="mt-16 flex flex-col items-center gap-2" style={{
        color: 'var(--color-text-muted)'
      }} data-id="element-185">
          <span className="text-xs tracking-widest uppercase" data-id="element-186">
            Continúa leyendo
          </span>
          <motion.div animate={{
          y: [0, 6, 0]
        }} transition={{
          repeat: Infinity,
          duration: 1.5,
          ease: 'easeInOut'
        }} data-id="element-187">
            <ChevronDownIcon className="w-5 h-5" data-id="element-188" />
          </motion.div>
        </motion.div>
      </div>
    </section>;
}